import config from "config/config";

export const isMITPolicy = (policy) => {
  const { product } = policy || {};
  const policyType = product?.type;
  const MIT_POLICY_PRODUCT_CODE = config.MIT_POLICY_PRODUCT_CODE?.split(",");

  if (!policyType || typeof policyType !== "string") return false;
  return MIT_POLICY_PRODUCT_CODE.includes(policyType.trim().toUpperCase());
};
